import { ChakraProvider } from '@chakra-ui/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useCustomTheme } from '@hooks/useCustomTheme';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'src/styles/fonts.css';
import { Router } from '@navigation/routes';
import { CookiesProvider } from 'react-cookie';

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
			retry: false,
			cacheTime: 1000 * 60,
			staleTime: 1000 * (2 * 60),
		},
	},
});

// Breakpoints padrões do Chakra-UI
const breakpoints = {
	base: '23.438rem', // 375px
	sm: '30em', // 480px
	md: '48em', // 768px
	lg: '62em', // 992px
	xl: '80em', // 1280px
	'2xl': '96em', // 1536px
};

export const App = () => {
	const customTheme = useCustomTheme(breakpoints);

	return (
		<CookiesProvider>
			<QueryClientProvider client={queryClient}>
				<ChakraProvider theme={customTheme}>
					<Router />

					<ToastContainer
						position="top-right"
						autoClose={5000}
						hideProgressBar={false}
						newestOnTop={false}
						closeOnClick
						rtl={false}
						pauseOnFocusLoss
						draggable
						pauseOnHover
						theme="colored"
					/>
				</ChakraProvider>
			</QueryClientProvider>
		</CookiesProvider>
	);
};
